import React from 'react'
import Anexos from './Anexos'
import Parse from 'html-react-parser'
import { Icon } from './../../../components/Layout'

const Licencas = React.memo(({ licenca }) => {

    const statusMap = {
        'vencida': 'status-vencida',
        'vencendomes': 'status-vencendo',
        'default': 'status-aberta'
    }

    const cardStatusClass = statusMap[licenca.circleStatus] || statusMap['default']
    const iconClass = licenca.circleStatus === 'vencida' ? 'ti-alert text-danger' :
        licenca.circleStatus === 'vencendomes' ? 'ti-time text-warning' : 'ti-id-badge text-info'

    return (
        <div className={`card cond-card ${cardStatusClass}`}>
            <div className="card-body">

                {/* Top Section: Icon + Title + Status Badge */}
                <div className="cond-header">
                    <div className="cond-title-group">
                        <div className="cond-icon-wrapper">
                            <i className={`cond-icon ${iconClass}`}></i>
                        </div>
                        <div className="cond-main-info">
                            <h4 className="cond-title">{licenca.objeto_licenciado}</h4>
                            <div className="cond-subtitles">
                                {licenca.cliente && (
                                    <div className="cond-subtitle-row row-client">
                                        <Icon name="ti-user" />
                                        <span>{licenca.cliente}</span>
                                    </div>
                                )}
                                {licenca.clienteemail && (
                                    <div className="cond-subtitle-row">
                                        <Icon name="ti-email" />
                                        <span>{licenca.clienteemail}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="cond-badges">
                        <span style={{ fontWeight: 600, fontSize: '11px', textTransform: 'uppercase', color: 'var(--color-text-primary)' }}>{Parse(String(licenca.situacao))}</span>
                    </div>
                </div>

                {/* Middle Section: Meta Info (Processo, Licença, etc) */}
                <div className="cond-meta-grid">
                    <div className="meta-item">
                        <span className="meta-label">Processo</span>
                        <span className="meta-value">
                            {licenca.numero_processo ? licenca.numero_processo : <span className="text-missing">Não informado</span>}
                        </span>
                    </div>
                    <div className="meta-item">
                        <span className="meta-label">Licença</span>
                        <span className="meta-value">
                            {licenca.numero_licenca ? licenca.numero_licenca : <span className="text-missing">Não informado</span>}
                        </span>
                    </div>
                </div>

                {/* Attachments if any */}
                {licenca.listaAnexos && licenca.listaAnexos.length > 0 &&
                    <div className="cond-anexos-wrapper">
                        <Anexos anexos={licenca.listaAnexos} />
                    </div>
                }

                {/* Footer Section: User & Dates */}
                <div className="cond-footer">
                    <div className="user-info">
                        <img src={licenca.avatar} alt={licenca.usuario} />
                        <div className="user-details">
                            <span className="name">{licenca.usuario}</span>
                            <span className="role">{licenca.nivel}</span>
                        </div>
                    </div>

                    <div className="date-info" style={{ alignItems: 'flex-start' }}>
                        <div className="date-block" style={{ alignItems: 'flex-end' }}>
                            <span className="date-label" style={{ fontWeight: 600, fontSize: '10px' }}>VALIDADE</span>
                            <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px' }}>
                                <span className={`date-val ${licenca.circleStatus === 'vencida' ? 'text-danger' : ''}`} style={{ fontSize: '14px' }}>
                                    {licenca.data_validade !== 'Invalid date' ? licenca.data_validade : 'Data inválida'}
                                </span>
                                {/* <span style={{ fontSize: '10px', color: 'var(--color-text-tertiary)', textTransform: 'uppercase' }}>
                                    {licenca.data_validade_from !== 'Invalid date' ? licenca.data_validade_from.replace('-', '').trim() : ''}
                                </span> */}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
})

export default Licencas